import { Button, Stack, Typography, useTheme } from '@mui/material';
import mixpanel from 'mixpanel-browser';
import { FC, useContext, useEffect } from 'react';
import GlobalContext from '../../contexts/GlobalContext';
import { IconCircleCheck2, IconCircleCheck3 } from '../../icons/Icons';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';
import { EMixpanelEvent } from '../../util/constants';

const MigrateAccountSuccess: FC = () => {
    const { coBranding, language, fullLoginLink } = useContext(GlobalContext);
    const theme = useTheme();

    const handleConfirm = () => {
        mixpanel.track(EMixpanelEvent.interacted, { key: 'consumer_migration_success' });
        window.location.assign(fullLoginLink);
    };

    useEffect(() => {
        mixpanel.track(EMixpanelEvent.viewed, { key: 'consumer_migration_success' });
    }, []);

    return (
        <PageLayoutV2>
            <Stack alignItems={'center'} sx={{ my: 3 }}>
                {coBranding.brandColor ? (
                    <IconCircleCheck3 fillColor={theme.palette.primary.main} />
                ) : (
                    <IconCircleCheck2 />
                )}
                <Typography component={'h1'} sx={{ fontSize: '22px', fontWeight: 700, mt: 3 }}>
                    {language.accountMigration.success.header}
                </Typography>
                <Typography variant="body2" component={'p'} color={'info'}>
                    {language.accountMigration.success.desc}
                </Typography>
                <Button variant="contained" fullWidth onClick={handleConfirm} sx={{ mt: 4 }} size="large">
                    {language.accountMigration.success.cta}
                </Button>
            </Stack>
        </PageLayoutV2>
    );
};

export default MigrateAccountSuccess;
